import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { 
  createTripPlanDocument, 
  updateTripPlan, 
  canUserCreateTripPlan 
} from '../../utils/tripPlanUtils';
import TripPlanForm from './TripPlanForm';

const TripPlanModal = ({ 
  isOpen, 
  onClose, 
  tripPlan = null, 
  onSuccess 
}) => {
  const { currentUser } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Check if user can create/edit trip plans
  if (!canUserCreateTripPlan(currentUser?.role)) {
    return null;
  }

  const handleSubmit = async (formData) => {
    try {
      console.log('🎯 TripPlanModal handleSubmit called');
      console.log('👤 Current user:', currentUser);
      console.log('📝 Form data received:', formData);
      
      setIsSubmitting(true);
      
      if (tripPlan && tripPlan.id) {
        console.log('🔄 Updating existing trip plan:', tripPlan.id);
        // Update existing trip plan
        const result = await updateTripPlan(tripPlan.id, formData);
        console.log('📊 Update result:', result);
        
        if (result.success) {
          alert('อัพเดททริปสำเร็จ!');
          onSuccess?.('update', { id: tripPlan.id, ...formData });
          onClose();
        } else {
          throw new Error(result.error);
        }
      } else {
        console.log('🆕 Creating new trip plan');
        // Create new trip plan
        const result = await createTripPlanDocument(
          currentUser.uid,
          currentUser.displayName || currentUser.email,
          currentUser.role,
          formData
        );
        
        console.log('📊 Create result:', result);
        
        if (result.success) {
          alert('สร้างทริปสำเร็จ!');
          onSuccess?.('create', { id: result.tripPlanId, ...formData });
          onClose();
        } else {
          throw new Error(result.error);
        }
      }
    } catch (error) {
      console.error('❌ Error submitting trip plan:', error);
      alert(`เกิดข้อผิดพลาด: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <TripPlanForm
          tripPlan={tripPlan}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={isSubmitting}
        />
      </div>
    </div>
  );
};

export default TripPlanModal;
